import EditHeroLinksForm from './EditHeroLinksForm';

export default EditHeroLinksForm;
